
<template>

    <section class="mentor-connection-approval">

        <div v-if="requests && mentors && terms && unconnected">
       

            <div v-for="(requests,term) in requests" class="panel">

                <div @click="!selectedTerm ? selectedTerm = term : selectedTerm = null" class="panel-heading">
                    <h2>{{getTermName(term)}} <i v-if="selectedTerm===term" class="fa fa-caret-down"></i><i v-else class="fa fa-caret-right"></i></h2>
                </div>
                <div class="panel-body" v-show="selectedTerm===term">
                <table class="table table-striped table-bordered requests">
                    <thead>
                        <tr>
                            <th>Mentor Name</th>
                            <th class="text-center">Student Name</th>
                            <th class="text-center">Approved by Mentor</th>
                            <th class="text-center">Approved by Student</th>
                            <th class="text-center">Reassign</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(requests, mentor) in requests">


                        <td colspan="5">

                         <router-link :to="{name: 'mentorProfile', params:{id:requests[0].mentor.id}}">{{mentor}}</router-link>

                            <ul>
                                <li v-for="request in requests">

                                    <div></div>
                                    <div>
                                        <router-link :to="{ name: 'student', params: { studentId: request.student.populiId }, query: {term: request.student.terms[2]}}">
                                            {{request.student.firstName}} {{request.student.lastName}}
                                        </router-link>
                                    </div>
                                    <div>
                                        <span v-if="request.approvedByMentor === false"><i class="fa fa-close declined"></i></span>
                                        <span v-if="request.approvedByMentor === true"><i class="fa fa-check approved"></i></span>
                                    </div>
                                    <div>
                                        <span v-if="request.approvedByStudent === false"><i class="fa fa-close declined"></i></span>
                                        <span v-if="request.approvedByStudent === true"><i class="fa fa-check approved"></i></span>
                                    </div>
                                    <div>
                                        <select class="form-control" @change="reassign(request, $event)" v-model="request.mentorId">
                                            <option v-for="mentor in mentors" :value="mentor.user.id">{{mentor.user.firstName}} {{mentor.user.lastName}}</option>
                                        </select>
                                    </div>
                                </li>
                            </ul>
                        </td>

                        </tr>
                    </tbody>
                </table>
                <div class="panel-heading">
                    <h2>Unconnected Students</h2>
                </div>
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="student in getUnconnectedForTerm(term)">
                            <td>
                            <router-link :to="{ name: 'student', params: { studentId: student.populiId }, query: {term: student.terms[2]}}">
                                {{student.firstName}} {{student.lastName}}
                            </router-link>
                            </td>

                        </tr>
                    </tbody>
                </table>
                </div>
            </div>


        </div>
    </section>

</template>

<script>

import mentors from '../services/mentors';
import terms from '../services/terms';

import _ from 'underscore';
import moment from 'moment';
import toastr from 'toastr';

export default {
    data() {
        return {
            requests: null,
            mentors:null,
            terms: null,
            selectedTerm: null,
            unconnected: [],
            showUnconnected: false
        }
    },
    components: {

    },
    mounted() {
        this.getRequests();
        this.getMentors();
        this.getTerms();
    },
    methods: {
        getUnconnectedForTerm(term) {
            var self = this;
            return this.unconnected.filter(function(u) {
                let currentTermEnds = self.terms.find(function(t){ return t.id == u.terms[2]}).endDate;
                let nextMentorShipTerm = self.terms.find(function(t) { return t.type === 'mentorship' && new Date(t.startDate) > new Date(currentTermEnds)});
                return nextMentorShipTerm.id == term;

            });

        },
        getTermName(id){
            const term =  this.terms.find(function(t) {return t.id == id})
            if (term) return term.name;
            return 'none';
        },
        getMentors() {
            var self = this;
            mentors.get(this).then(function(response){
                self.mentors = response.data.mentors;
            });
        },
        getTerms() {
            var self = this;
            terms.get(this).then(function(response){
                self.terms = response.data.terms.sort(function(a,b) { return new Date(a.startDate) - new Date(b.startDate)});
            });
        },
        getRequests() {
            var self = this;

            mentors.getRequests(this).then(function(response){
                let requests = _.groupBy(response.data.requests, function(req) {return req.term});
                Object.keys(requests).forEach(function(key) {
                    requests[key] = _.groupBy(requests[key], function(req) {return req.mentor.firstName + ' ' + req.mentor.lastName});
                });
                self.requests = requests;
                self.unconnected = response.data.unconnected;

            });
        },
        reassign(request, e) {
            var self = this;
            let data = {
                requestId: request.id,
                mentorId: e.target.value
            }
            mentors.reassign(this, data).then(function(response) {
                response.data.success === true ? self.getRequests() : toastr.error('Error reassigning');
            })
        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
    .panel-heading {
        cursor:pointer;
    }
    table {
        table-layout:fixed;

    }
    .approved {
        color: green;
    }
    .declined {
        color: red;
    }
    .inactive {
        color: grey;
    }
    .actionable {
        cursor:pointer;
    }
    .requests {
        li {
            padding: 1rem 0;
            display:flex;
            justify-content:space-between;
            & > div {
                width:16.6666666%;
                text-align:center;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// MentorConnectionApproval.vue?2c9dc6bc